import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const routemateConfig: TSPConfig = {
  key: 'routemate',
  name: 'RouteMate',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your RouteMate representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default routemateConfig;
